import React from 'react';
import { Box, Typography } from '@mui/material';

export default function TelusLogo(props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }} {...props}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#5b21b6' }}>
                TELUS
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 'normal', color: '#16a34a', ml: 0.5 }}>
                Health
            </Typography>
        </Box>
    );
}